var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStaffManager(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Staff_Manager_Default",
    "data-name": "Staff Manager Default",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.095,
    height: 80.095,
    viewBox: "0 0 80.095 80.095",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_132984",
    "data-name": "Path 132984",
    d: "M76.09,173.349H46.722a4,4,0,0,0-4,4v17.354a4,4,0,0,0,4,4H57.4v4h-5.34v2.67H40.047v-7.235a9.386,9.386,0,0,0-6.884-9.017l-7.8-2.122v-2a9.332,9.332,0,0,0,4-7.657v-1.335a1.335,1.335,0,0,0,1.335-1.335v-4A10.692,10.692,0,0,0,20.024,160H8.009a2.67,2.67,0,0,0-2.67,2.67v6.675a6.646,6.646,0,0,0,4.978,6.452c.119.033.242.048.362.074v1.484a9.332,9.332,0,0,0,4,7.657v2l-7.8,2.123A9.385,9.385,0,0,0,0,198.152v13.91A1.335,1.335,0,0,0,1.335,213.4H78.76a1.335,1.335,0,0,0,1.335-1.335v-5.34a1.335,1.335,0,0,0-1.335-1.335H70.75v-2.67h-5.34v-4H76.09a4,4,0,0,0,4-4V177.354a4,4,0,0,0-4-4Zm-68.08-4V162.67H20.024a8.017,8.017,0,0,1,8.009,8.009v2.67h-.881a2.678,2.678,0,0,1-2.59-2.017l-.574-2.309a1.337,1.337,0,0,0-1.029-.986,1.305,1.305,0,0,0-.266-.027,1.335,1.335,0,0,0-1.068.534l-.8,1.068a9.745,9.745,0,0,1-1.643,1.691,9.319,9.319,0,0,1-5.832,2.047H12.014a3.589,3.589,0,0,1-1.005-.134,3.987,3.987,0,0,1-3-3.871Zm5.34,8.009v-1.335a12,12,0,0,0,7.514-2.646,12.54,12.54,0,0,0,1.193-1.1,5.34,5.34,0,0,0,4.642,3.709v1.372a6.675,6.675,0,1,1-13.349,0Zm6.675,9.344a9.287,9.287,0,0,0,2.67-.4v1.735a1.321,1.321,0,0,0,.466.992l-3.136,2.612-3.136-2.611a1.32,1.32,0,0,0,.466-.993V186.3a9.286,9.286,0,0,0,2.67.4ZM7.586,191.711l6.3-1.714,5.286,4.4a1.336,1.336,0,0,0,1.709,0l5.286-4.4,6.293,1.712a6.71,6.71,0,0,1,4.921,6.443v7.235h-4v-6.675H30.7v6.675H9.344v-6.675H6.675v6.675h-4v-7.235a6.707,6.707,0,0,1,4.917-6.441Zm69.838,16.346v2.67H2.67v-2.67Zm-17.354-5.34V188.033h2.67v14.684Zm17.354-8.009a1.335,1.335,0,0,1-1.335,1.335H65.411V186.7a1.335,1.335,0,0,0-1.335-1.335h-5.34A1.335,1.335,0,0,0,57.4,186.7v9.344H46.722a1.335,1.335,0,0,1-1.335-1.335V177.354a1.335,1.335,0,0,1,1.335-1.335H76.09a1.335,1.335,0,0,1,1.335,1.335Zm0,0",
    transform: "translate(0 -133.302)",
    fill: "#9aafb5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_132985",
    "data-name": "Path 132985",
    d: "M289.373,0H265.344a4,4,0,0,0-4,4V5.34H260a4,4,0,0,0-4,4V28.033a4,4,0,0,0,4,4h24.028a4,4,0,0,0,4-4V26.7h1.335a4,4,0,0,0,4-4V4A4,4,0,0,0,289.373,0ZM260,8.009h24.028a1.335,1.335,0,0,1,1.335,1.335v1.335h-26.7V9.344A1.335,1.335,0,0,1,260,8.009Zm24.028,21.359H260a1.335,1.335,0,0,1-1.335-1.335V13.349h26.7V28.033A1.335,1.335,0,0,1,284.033,29.368Zm6.675-6.675a1.335,1.335,0,0,1-1.335,1.335h-1.335V9.344a4,4,0,0,0-4-4H264.009V4a1.335,1.335,0,0,1,1.335-1.335h24.028A1.335,1.335,0,0,1,290.708,4Zm0,0",
    transform: "translate(-213.283)",
    fill: "#9aafb5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_132986",
    "data-name": "Path 132986",
    d: "M344,112h2.67v2.67H344Zm0,0",
    transform: "translate(-286.599 -93.311)",
    fill: "#9aafb5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_132987",
    "data-name": "Path 132987",
    d: "M376,112h2.67v2.67H376Zm0,0",
    transform: "translate(-313.259 -93.311)",
    fill: "#9aafb5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_132988",
    "data-name": "Path 132988",
    d: "M312,112h2.67v2.67H312Zm0,0",
    transform: "translate(-259.938 -93.311)",
    fill: "#9aafb5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_132989",
    "data-name": "Path 132989",
    d: "M48,32h5.34v2.67H48Zm0,0",
    transform: "translate(-39.991 -26.66)",
    fill: "#9aafb5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_132990",
    "data-name": "Path 132990",
    d: "M96,32h16.019v2.67H96Zm0,0",
    transform: "translate(-79.981 -26.66)",
    fill: "#9aafb5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_132991",
    "data-name": "Path 132991",
    d: "M56,96h5.34v2.67H56Zm0,0",
    transform: "translate(-46.656 -79.981)",
    fill: "#9aafb5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_132992",
    "data-name": "Path 132992",
    d: "M104,96h16.019v2.67H104Zm0,0",
    transform: "translate(-86.646 -79.981)",
    fill: "#9aafb5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_132993",
    "data-name": "Path 132993",
    d: "M64,64h5.34v2.67H64Zm0,0",
    transform: "translate(-53.321 -53.321)",
    fill: "#9aafb5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_132994",
    "data-name": "Path 132994",
    d: "M112,64h16.019v2.67H112Zm0,0",
    transform: "translate(-93.311 -53.321)",
    fill: "#9aafb5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffManager);
export default __webpack_public_path__ + "static/media/StaffManager.796ebb975539dc5f5ed19c8737e2c8e4.svg";
export { ForwardRef as ReactComponent };